import PropTypes from 'prop-types'
import logoSvg from '../../../assets/images/adas-intelligence-sidebar-logo.svg'

/**
 * ADAS Intelligence brand logo — stacked Ai monogram + "ADAS intelligence"
 * wordmark, rendered from the reversed-color SVG so it reads correctly on
 * the dark Steel-blue sidebar. Pass `width` (default 160px); height
 * auto-scales to preserve the artwork's aspect ratio.
 */
export const AdasIntelligenceLogo = ({ width = 160, className = '', alt = 'ADAS Intelligence' }) => (
  <img src={logoSvg} alt={alt} width={width} className={className} style={{ height: 'auto', display: 'block' }} />
)

AdasIntelligenceLogo.propTypes = {
  width: PropTypes.number,
  className: PropTypes.string,
  alt: PropTypes.string
}
